export default __webpack_public_path__ + "static/media/expl-nn_15_DE.cdf589df.png";